import React, { useState } from "react";
import { FaSearch, FaPencilAlt, FaTrashAlt } from "react-icons/fa";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useNavigate } from "react-router-dom";

export default function WardAllocation() {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const wards = [
    {
      id: 1,
      number: "Ward 101",
      capacity: 5,
      occupied: 3,
      status: "Available",
    },
    { id: 2, number: "Ward 102", capacity: 3, occupied: 3, status: "Full" },
    {
      id: 3,
      number: "Ward 103",
      capacity: 2,
      occupied: 1,
      status: "Available",
    },
    { id: 4, number: "Ward 104", capacity: 4, occupied: 4, status: "Full" },
    {
      id: 5,
      number: "Ward 105",
      capacity: 5,
      occupied: 0,
      status: "Maintenance",
    },
  ];

  const statusColors = {
    Available: "bg-green-500",
    Full: "bg-red-500",
    Maintenance: "bg-yellow-500",
  };

  const filteredWards = searchTerm
    ? wards.filter((ward) =>
        ward.number.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : wards;

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      {/* Header */}
      <div className="mb-8 flex justify-between items-center">
        <h1 className="text-3xl font-bold text-gray-800">Ward Allocation</h1>
        <div className="relative">
          <input
            type="text"
            placeholder="Search wards..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10 pr-4 py-2 w-72 border border-gray-300 rounded shadow-md focus:outline-none focus:ring-2 focus:ring-blue-300"
          />
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        </div>
      </div>

      {/* Ward Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredWards.map((ward) => {
          const occupancyRate = Math.floor(
            (ward.occupied / ward.capacity) * 100
          );

          return (
            <div
              key={ward.id}
              className="relative bg-white shadow-md rounded-lg overflow-hidden transition transform hover:scale-105 hover:shadow-lg"
              onClick={() => {
                navigate(`/new/ward/${ward.id}`);
              }}
            >
              {/* Status Badge */}
              <span
                className={`absolute top-4 left-4 px-3 py-1 text-sm font-semibold rounded-full text-white ${statusColors[ward.status]}`}
              >
                {ward.status}
              </span>

              {/* Circular Progress Indicator */}
              <div className="flex justify-center items-center bg-gradient-to-br from-blue-100 via-white to-blue-50 p-6">
                <div className="w-24 h-24">
                  <CircularProgressbar
                    value={occupancyRate}
                    text={`${occupancyRate}%`}
                    styles={buildStyles({
                      textSize: "16px",
                      pathColor:
                        ward.status === "Available" ? "#22c55e" : "#f87171",
                      textColor: "#374151",
                      trailColor: "#e5e7eb",
                    })}
                  />
                </div>
              </div>

              {/* Ward Info */}
              <div className="p-4 text-center">
                <h2 className="text-xl font-semibold text-gray-800">
                  {ward.number}
                </h2>
                <p className="text-gray-600">
                  {ward.occupied} / {ward.capacity} Occupied
                </p>
              </div>

              {/* Action Buttons */}
              <div className="p-4 flex justify-around border-t border-gray-200">
                <button className="p-2 bg-blue-500 text-white rounded-full hover:bg-blue-600">
                  <FaPencilAlt />
                </button>
                <button className="p-2 bg-red-500 text-white rounded-full hover:bg-red-600">
                  <FaTrashAlt />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
